import { useState } from "react";
import { motion } from "framer-motion";
import { LuNotebookPen } from "react-icons/lu";
import FloatingInput from "../../../common/FloatingInput";
import Button from "../../../common/Button";
import { containerVariants, itemVariants } from "../../../common/MotionVariants";
import { EMPTY_FORM } from "../../../utils/Constant";
import { CountryCodeSelect, usePhoneParts } from "../../../common/PhoneInput";
import { phoneError } from "../../../utils/phone";

export default function RegisterOrgForm({ onSubmit, loading, onBack }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [showPhoneError, setShowPhoneError] = useState(false);

  const update = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const phone = usePhoneParts(form.contactNumber, (value) =>
    setForm((prev) => ({ ...prev, contactNumber: value }))
  );
  // Contact number is optional, but must be valid when entered
  const contactError = showPhoneError ? phoneError(form.contactNumber) : "";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phoneError(form.contactNumber)) {
      setShowPhoneError(true);
      return;
    }
    onSubmit(form);
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="flex flex-col gap-5"
      noValidate
      variants={containerVariants}
      initial="hidden"
      animate="show"
    >
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <motion.div variants={itemVariants}>
          <FloatingInput id="orgName" label="Organization name" required value={form.orgName} onChange={update("orgName")} />
        </motion.div>
        <motion.div variants={itemVariants}>
          <FloatingInput id="userName" label="Your name" required value={form.userName} onChange={update("userName")} />
        </motion.div>
        <motion.div variants={itemVariants}>
          <FloatingInput id="org-email" label="Email address" required type="email" value={form.email} onChange={update("email")} />
        </motion.div>
        <motion.div variants={itemVariants}>
          <div className="flex items-start gap-2">
            <CountryCodeSelect
              value={phone.dial}
              onChange={phone.changeDial}
              className="h-[46px] rounded-md border border-white/15 bg-transparent px-2 text-sm text-white hover:border-white/25 focus:border-[#3652FF] [&>option]:bg-[#0B111C]"
            />
            <div className="min-w-0 flex-1">
              <FloatingInput
                id="contactNumber"
                label="Contact number"
                type="tel"
                inputMode="numeric"
                value={phone.number}
                onChange={(e) => {
                  phone.changeNumber(e.target.value);
                  setShowPhoneError(false);
                }}
                error={contactError}
              />
            </div>
          </div>
        </motion.div>
        <motion.div variants={itemVariants}>
          <FloatingInput id="designation" label="Designation" value={form.designation} onChange={update("designation")} />
        </motion.div>
        <motion.div variants={itemVariants}>
          <FloatingInput id="taxId" label="Tax ID" value={form.taxId} onChange={update("taxId")} />
        </motion.div>
      </div>

      <motion.div variants={itemVariants}>
        <FloatingInput id="address" label="Address" value={form.address} onChange={update("address")} />
      </motion.div>

      <motion.div variants={itemVariants}>
        <Button type="submit" icon={LuNotebookPen} variant="accent" loading={loading}>
          Register organization
        </Button>
      </motion.div>
    </motion.form>
  );
}